<div class="dialog">
    <div class="dialog-header">
        表头设置
    </div>
    <div class="dialog-body">
        <div class="grid">
            <div class="row">
                <div class="column background-page" [style.width]="240 + 'px'">
                    常规通用字段
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="40 + 'px'">
                    <input type="checkbox" [(ngModel)]="checkall" (ngModelChange)="onCheckAllChange()">
                </div>
                <div class="column background-page" [style.width]="100 + 'px'">
                    字段名称
                </div>
                <div class="column background-page" [style.width]="50 + 'px'">
                    对齐
                </div>
                <div class="column background-page" [style.width]="50 + 'px'">
                    宽度
                </div>
            </div>
            <div class="row" *ngFor="let item of recordList">
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" [(ngModel)]="item.selected" (ngModelChange)="onCheckChange()">
                </div>
                <div class="column {{item.selected ? 'color-primary' : ''}}" [style.width]="100 + 'px'">
                    <format-data [contentStr]="item.name" [patternStr]="'E+100'"></format-data>
                </div>
                <div class="column {{item.selected ? 'color-primary' : ''}}" [style.width]="50 + 'px'">
                    <select [(ngModel)]="item.horizontal">
                        <option *ngFor="let opts of FormHeaderHorizontalList" [value]="opts.value">{{opts.label}}
                        </option>
                    </select>
                </div>
                <div class="column {{item.selected ? 'color-primary' : ''}}" [style.width]="50 + 'px'">
                    <input type="text" [(ngModel)]="item.width" appDigitalFormat>
                </div>
            </div>
        </div>
        <div class="grid">
            <div class="row">
                <div class="column background-page" [style.width]="240 + 'px'">
                    表单特定字段
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="40 + 'px'">
                    <input type="checkbox" [(ngModel)]="checkall2" (ngModelChange)="onCheckAll2Change()">
                </div>
                <div class="column background-page" [style.width]="100 + 'px'">
                    字段名称
                </div>
                <div class="column background-page" [style.width]="50 + 'px'">
                    对齐
                </div>
                <div class="column background-page" [style.width]="50 + 'px'">
                    宽度
                </div>
            </div>
            <div class="row" *ngFor="let item of recordList2">
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" [(ngModel)]="item.selected" (ngModelChange)="onCheckChange()">
                </div>
                <div class="column {{item.selected ? 'color-primary' : ''}}" [style.width]="100 + 'px'">
                    <format-data [contentStr]="item.name" [patternStr]="'E+100'"></format-data>
                </div>
                <div class="column {{item.selected ? 'color-primary' : ''}}" [style.width]="50 + 'px'">
                    <select [(ngModel)]="item.horizontal">
                        <option *ngFor="let opts of FormHeaderHorizontalList" [value]="opts.value">{{opts.label}}
                        </option>
                    </select>
                </div>
                <div class="column {{item.selected ? 'color-primary' : ''}}" [style.width]="50 + 'px'">
                    <input type="text" [(ngModel)]="item.width" appDigitalFormat>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button nz-button nzType="default" (click)="cancel()">取消</button>
        <button nz-button nzType="primary" (click)="confirm()" [disabled]="!canConfirm">确认</button>
    </div>
</div>